export const environment = {
  production: true,
  region: 'usa',
  timezone: '',
  locale: 'en',
  client_folder: 'base',
  products_enabled: [],
  config_from_api: false,
  secure: false,
  orchUrl: 'https://b2c-orch-prod.biz2credit.com/',
  X_TENANT_ID: '3e0c16d7-7ff2-4755-ac16-5ad7a788cbf4',
  X_TENANT_ID_PROD: '3e0c16d7-7ff2-4755-ac16-5ad7a788cbfp',
  encryptionKey: "//htps12345nrfbw",
  recaptchaSiteKey: "",
  email: {
    site_url: 'https://flow.biz2credit.com',
    header_logo_path_1: 'https://flow.biz2credit.com/assets/images/logo.png',
    header_logo_path_2: '#',
    send_mail_logo: `${window.location.origin}/assets/images/logo2.png`,
    senders_name: 'Biz2Credit',
    copyright_text: '2021 Biz2Credit',
    privacy: '#',
    terms: '#',
    no_reply_mail: ''
  },
  redirect_url: 'https://cj.biz2credit.com/',
  siteURL: 'https://flow.biz2credit.com/emdedded',
  appRedirectUrl: 'https://app.biz2credit.com/',
  domain: 'biz2credit.com',
  tokenExpiryThresholdSeconds: 300,
  firebase: {
    apiKey: "AIzaSyDotR3bZtGIwOUyn7J0aoNfN3pu5ISzmX8",
    authDomain: "marketplace-fcm-demo.firebaseapp.com",
    projectId: "marketplace-fcm-demo",
    storageBucket: "marketplace-fcm-demo.firebasestorage.app",
    messagingSenderId: "150522405980",
    appId: "1:150522405980:web:bf538a8b16dfbcc3f3b299",
    vapidKey: 'BGXZiRW2tws2tna48vn7ZqbqwwpRJ9Ad5FEwIxiqfxofZs0vMT0NcSYbuenw8Y7hfNsjGIYxxA46peKp45qLeR8',
  },
  websocketUrl: 'wss://sln9jle4sd.execute-api.us-east-1.amazonaws.com/master',
};
